// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3GUC1","title":"BackImages_title__2Tric","images":"BackImages_images__1vPnY"};